import { useEffect, useState } from "react";
import { api } from "../api/client";
import { useIsDesktop } from "../lib/useIsDesktop";
import type { AboutResponse } from "../api/types";

export function About() {
  const [data, setData] = useState<AboutResponse | null>(null);
  const isDesktop = useIsDesktop();

  useEffect(() => {
    api.get<AboutResponse>("/public/about").then(setData).catch(() => {});
  }, []);

  if (!data) return <div style={{ padding: 32 }}>Loading…</div>;

  return (
    <div style={{ padding: isDesktop ? "64px 64px 80px" : "24px 22px 32px" }}>
      <div style={{ maxWidth: 720, margin: "0 auto" }}>
        <div style={{ fontSize: 12, fontWeight: 700, color: "var(--accent)", letterSpacing: 0.6, textTransform: "uppercase" }}>
          {data.aboutEyebrow}
        </div>
        <h1 style={{ margin: "8px 0 0", fontFamily: "var(--display)", fontSize: isDesktop ? 56 : 36, fontWeight: 400, letterSpacing: -1.4, lineHeight: 1.05 }}>
          {data.aboutHeadline}
        </h1>

        <div style={{ marginTop: 28, fontSize: isDesktop ? 17 : 15.5, lineHeight: 1.65 }}>
          {data.aboutParagraphs.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>

        <h2 style={{ marginTop: 56, fontFamily: "var(--display)", fontSize: 28, fontWeight: 400, letterSpacing: -0.6 }}>
          How pledges work
        </h2>
        <div style={{ background: "var(--surface)", border: "1px solid var(--line)", borderRadius: 16, overflow: "hidden" }}>
          {data.aboutFaqs.map((f, i) => (
            <details key={i} style={{ borderBottom: i === data.aboutFaqs.length - 1 ? "none" : "1px solid var(--line)" }}>
              <summary style={{ cursor: "pointer", padding: "18px 20px", fontSize: 15, fontWeight: 600, listStyle: "none", display: "flex", justifyContent: "space-between" }}>
                {f.q}
                <span style={{ color: "var(--ink-soft)" }}>+</span>
              </summary>
              <div style={{ padding: "0 20px 18px", fontSize: 14.5, color: "var(--ink-soft)", lineHeight: 1.6 }}>{f.a}</div>
            </details>
          ))}
        </div>

        <div style={{ marginTop: 40, padding: 24, background: "var(--surface)", border: "1px solid var(--line)", borderRadius: 16 }}>
          <div style={{ fontSize: 12, color: "var(--ink-soft)", textTransform: "uppercase", letterSpacing: 0.6, fontWeight: 600 }}>
            Who this supports
          </div>
          <div style={{ fontFamily: "var(--display)", fontSize: 24, fontWeight: 400, marginTop: 6 }}>
            {data.charity}
          </div>
          <p style={{ fontSize: 14, color: "var(--ink-soft)", marginTop: 6 }}>
            Ride4Baker is an independent fundraiser and isn't operated by {data.charity}. This site
            collects no payments — you donate directly on GoFundMe, and all funds raised go to{" "}
            {data.charity}.
          </p>
        </div>
      </div>
    </div>
  );
}
